import Joi, { ValidationError } from "joi";
import { findIntersectingSpiffRules } from "../../helpers/SpiffRuleValidator";

const ruleSchema = Joi.object({
	make: Joi.string().allow(""),
	model: Joi.string().allow(""),
	trim: Joi.string().allow(""),
	status: Joi.array().items(Joi.string().required()),
	rangeType: Joi.string().allow(""),
	startYear: Joi.string().allow(""),
	endYear: Joi.string().allow(""),
	stockExpression: Joi.string().allow(""),
});

export const eligibilityRequirementsSalesSchema = Joi.object({
	rules: Joi.array()
		.items(ruleSchema)
		.custom((value, helpers) => {
			const errorDetails = findIntersectingSpiffRules(value);
			if (errorDetails.length) {
				return helpers.error("array.unique", { details: errorDetails });
			}
			return value;
		}, "Check intersected rules"),
});

export const eligibilityRequirementsTradesSchema = Joi.object({
	franchises: Joi.array().items(Joi.string().required()),
});

export type TErrors = ValidationError | null;

export type TPath = (string | number)[];

export const eligibilityRequirementsDepartmentSchema = Joi.object({
	selectedPayType: Joi.array().items(Joi.string().required()),
	selectedDepartment: Joi.array().items(Joi.string().required()),
});

export const eligibilityRequirementsOpCodesSchema = Joi.object({
	selectedPayType: Joi.array().items(Joi.string().required()),
	selectedOperationCodes: Joi.array().items(Joi.object().required()),
	selectedTimeLapse: Joi.string().required(),
});
